export const GET = Object.freeze({
  REQUEST: 'dailyCheckOperation/GET_REQUEST',
  SUCCESS: 'dailyCheckOperation/GET_SUCCESS',
  ERROR: 'dailyCheckOperation/GET_ERROR',
});

export const FIND = Object.freeze({
  REQUEST: 'dailyCheckOperation/FIND_REQUEST',
  SUCCESS: 'dailyCheckOperation/FIND_SUCCESS',
  ERROR: 'dailyCheckOperation/FIND_ERROR',
});

export const CREATE = Object.freeze({
  REQUEST: 'dailyCheckOperation/CREATE_REQUEST',
  SUCCESS: 'dailyCheckOperation/CREATE_SUCCESS',
  ERROR: 'dailyCheckOperation/CREATE_ERROR',
});

export const UPDATE = Object.freeze({
  REQUEST: 'dailyCheckOperation/UPDATE_REQUEST',
  SUCCESS: 'dailyCheckOperation/UPDATE_SUCCESS',
  ERROR: 'dailyCheckOperation/UPDATE_ERROR',
});

export const DELETE = Object.freeze({
  REQUEST: 'dailyCheckOperation/DELETE_REQUEST',
  SUCCESS: 'dailyCheckOperation/DELETE_SUCCESS',
  ERROR: 'dailyCheckOperation/DELETE_ERROR',
});

export const RESET_STATE = 'dailyCheckOperation/RESET_STATE';

export const GET_OPERATIONS_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: GET.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: GET.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: GET.ERROR,
    payload,
    error: true,
  }),
});

export const FIND_OPERATION_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: FIND.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: FIND.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: FIND.ERROR,
    payload,
    error: true,
  }),
});

export const CREATE_OPERATION_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: CREATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: CREATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: CREATE.ERROR,
    payload,
    error: true,
  }),
});

export const UPDATE_OPERATION_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: UPDATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: UPDATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: UPDATE.ERROR,
    payload,
    error: true,
  }),
});

export const DELETE_OPERATION_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: DELETE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: DELETE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: DELETE.ERROR,
    payload,
    error: true,
  }),
});
